import { render, staticRenderFns } from "./list-itineraries.vue?vue&type=template&id=70c770c8&"
import script from "./list-itineraries.vue?vue&type=script&lang=js&"
export * from "./list-itineraries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports